import { lazy } from 'react';

// Keep each article (and its charts) out of the initial page bundle.
export const blogPostComponents = {
  'cybersecurity-risk-bubble': lazy(() => import('./posts/cybersecurity-risk-bubble.jsx')),
  'ai-federalism-preemption': lazy(() => import('./posts/ai-federalism-preemption.jsx')),
  'statutory-construction-ai': lazy(() => import('./posts/statutory-construction-ai.jsx')),
  'biorisk-eval': lazy(() => import('./posts/bioriskeval.jsx')),
  'public-defender-ai': lazy(() => import('./posts/PublicDefenderBlogPost.jsx')),
  'oral-args-eval': lazy(() => import('./posts/oral-args-eval.jsx')),
  'simulating-people': lazy(() => import('./posts/simulating-people.jsx')),
};

export const isValidBlogPostId = (id) =>
  Object.prototype.hasOwnProperty.call(blogPostComponents, id);

export const getBlogPostComponent = (id) =>
  isValidBlogPostId(id) ? blogPostComponents[id] : undefined;
